import {gsap} from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

/**
 * @param anchor
 * @param duration
 * @param link
 * @param context
 * @param correction
 */
export const scrollTo = (anchor, duration = 1.75, link, context, correction = 0) => {

	link = link || null;
	// const contextBody = context || document.body;
	context = context || window;
	const target = typeof anchor === 'string' ? document.querySelector(anchor) : anchor;
	if (!target) return;
	const targetPos = target.getBoundingClientRect();
	// const header = HeaderPARAMS.header
	// const nav = document.querySelector('#nav-sommaire')
	const frontCorrection = parseInt( link && link.dataset.scroll ? link.dataset.scroll : correction )

	let position = targetPos.top + window.scrollY
	position = position + frontCorrection


	const header = document.querySelector('#header')
	if (header) {
		if (targetPos.top < 0) {
			position = position - header.getBoundingClientRect().height
		}
	}
	// if (nav) {
	// 	const navRect = nav.getBoundingClientRect();
	// 	if (navRect.y <= 0) {
	// 		position = position - navRect.height
	// 	}
	// }

	// if ((position + HeaderPARAMS.upDelta) < window.scrollY) {
	// 	const headerRect = header.getBoundingClientRect();
	// 	position = position - headerRect.height
	// }

	return scroll(position, context, duration)
}

export const scroll = (position, context, duration = 1.75) => {
	context = context || window
	return new Promise((resolve) => {
		gsap.to(context, {
			scrollTo: {
				y: position,
			},
			ease: "Expo.easeInOut",
			duration: duration,
			onComplete: () => {
				resolve()
			}
		})
	})
}

const scrollToAction = () => {
	if (location.hash !== '' && location.hash !== undefined) {
		setTimeout(() => {
			scrollTo(location.hash, 1.75, null, null, -30)
		},100)
	}
	document.addEventListener('click', function (event) {
		if (
			event.target.closest('a[href^="#"]:not([href="#"]):not([href^="#plyr"])')
		) {
			const closest = event.target.closest('a[href^="#"]:not([href="#"]):not([href^="#plyr"])')
			event.preventDefault();
			scrollTo(closest.getAttribute('href'), 1.75, closest, null, -30)
		}
	});
}

scrollToAction()
